<template>

    <div class="row m-1 mt-2">

        <a ref="attachmentA"></a>

        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                          
                            <form @submit.prevent="downloadts">
                                <h3>Esporta fatture manuali</h3>
                                <hr>
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="f">Dal</label>
                                            <input type="date" name="f" v-model="from" class="form-control" />

                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="col-form-label" for="t">Al</label>
                                            <input type="date" name="t" v-model="to" class="form-control" />
                                        </div>
                                    </div>

                                </div>

                                <div class="row">


                                </div>
               

                                <div class="form-group mt-3">
                            
                                    <button type="submit" class="btn  btn-xs  btn-primary" >Salva  <font-awesome-icon :icon="['far','save']"></font-awesome-icon></button>
                                </div>
                            </form>
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>

    </div>


</template>
<style>
    a {
        cursor:pointer;
    }
    .row [class*='col'] {
        transition: all 0.5s ease-in-out;
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .swal2-shown {
        z-index:999999;
    }
</style>
<script>

    import axios from 'axios'




    export default {
   
        data() {
            return {
                from: null,
                to:null
            }

        },
        name: 'tsexport',
       
        methods: {

          
            downloadts: function (id, f, o) {
                var me = this;
                var url = 'ts/files?from=' + (me.from || '') + "&to="+(me.to || '');
                var o = `ExportFattureManuali_${me.from || ''}_${me.to || ''}.xlsx`;
                axios.get(url, { responseType: 'blob' }).then(function (result) {
                    var blob = new Blob([result.data], { type: result.headers["content-type"] });
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                        window.navigator.msSaveOrOpenBlob(blob, o);
                    } else {
                        me.$refs.attachmentA.href = URL.createObjectURL(blob)
                        me.$refs.attachmentA.download = o;
                        me.$refs.attachmentA.click()
                    }
                });

            }
        }
    };
</script>
